import React from 'react';
import './Badge.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBadgeCheck,
  faStarHalfAlt,
  faCrown
} from "@fortawesome/pro-duotone-svg-icons";
import {BADGES} from '../../../../const/badge';



const Badge = ({user,...props})=>{
    const {style = {}} = props;
    const BADGE_MAPPING = {
        [BADGES.CERTIFIED]: <BadgeCertified style={style} />,
        [BADGES.GOLD]: <BadgeGold style={style} />,
        [BADGES.VOISSA_PLUS]: <BadgeVoissaPlus style={style} />,
        [BADGES.NEW_USER]: <BadgeNewUser style={style} />,
        [BADGES.ADMIN]: <BadgeAdmin style={style} />,
        [BADGES.MODO]: <BadgeModo style={style} />
    }
    return BADGE_MAPPING[user?.badge] ? BADGE_MAPPING[user?.badge] : null;
};

export const BadgeAdmin = ({ style = {} }) => (
    <FontAwesomeIcon className="certified-badge" icon={faCrown} style={{
        "--fa-primary-color": "#facc15",       
        "--fa-secondary-color": "#000000",    
        "--fa-secondary-opacity": "1",
        fontSize: "1em",
        ...style,
    }} />
);

export const BadgeModo = ({ style = {} }) => (
    <FontAwesomeIcon className="certified-badge" icon={faCrown} style={{
        "--fa-primary-color": "#9b59b6",       
        "--fa-secondary-color": "#9b59b6",    
        "--fa-secondary-opacity": "1",
        fontSize: "1em",
        ...style,
    }} />
);

export const BadgeCertified= ({ style = {} }) => (
    <FontAwesomeIcon className="certified-badge" icon={faBadgeCheck} style={{
        "--fa-primary-color": "#ffffff",
        "--fa-secondary-color": "#0095ff", 
        "--fa-secondary-opacity": "1",
        fontSize: "1em",
        ...style,
    }}/>
);

export const BadgeGold= ({ style = {} }) => (
    <FontAwesomeIcon className="certified-badge" icon={faBadgeCheck} style={{
        "--fa-primary-color": "#ffffff",
        "--fa-secondary-color": "#e1c56a", 
        "--fa-secondary-opacity": "1",
        fontSize: "1em",
        ...style,
    }}/>
);

export const BadgeVoissaPlus = ({ style = {} }) => (
    <FontAwesomeIcon className="certified-badge" icon={faBadgeCheck} style={{
        "--fa-primary-color": "#ffffff",
        "--fa-secondary-color": "#c0c6cf", // argent (Voissa Plus)
        "--fa-secondary-opacity": "1",
        fontSize: "1em",
        ...style,
    }}/>
);

export const BadgeNewUser = ({ style = {} }) => (
    <FontAwesomeIcon className="certified-badge" icon={faStarHalfAlt} style={{
        "--fa-primary-color": "#f59e0b",       
        "--fa-secondary-color": "#fde047",   
        "--fa-secondary-opacity": "1",
        fontSize: "1em",
        ...style,
    }} />
);


export default Badge;